<wlm-spinner-wrapper
  [showSpinner]="showSpinner"
  [ngClass]="{
    'custom-dialog-content-inline': styles?.contentInline
  }"
>
  <div
    [class]="'popup-container ' + (popupContainerClass || '')"
    [ngStyle]="popupWidth ? { width: popupWidth } : null"
  >
    <div class="header-container">
      <div class="header-title">
        <button
          *ngIf="showArrowIcon"
          mat-icon-button
          class="button-position button"
          color="primary"
          (click)="onClose()"
        >
          <wlm-icon [icon]="'arrow_back'"></wlm-icon>
        </button>
        <h3
          *ngIf="titleKey || customTitle"
          [class.title]="titleKey"
          [class.customTitle]="customTitle"
        >
          <ng-container *ngIf="subTitle; else onlyTitle">
            {{ titleKey || customTitle | translate : titleKeyParams }}: {{ subTitle }}
          </ng-container>
          <ng-template #onlyTitle>
            {{ titleKey || customTitle | translate : titleKeyParams }}
          </ng-template>
        </h3>
        <h3 *ngIf="title" class="title">{{ title }}</h3>
      </div>
      <div class="header-icons">
        <ng-content select="[popup-top-icons]"></ng-content>
      </div>
    </div>

    <hr *ngIf="titleKey || title || customTitle" class="title-separator" />

    <mat-dialog-content [class]="'dialog-content ' + (contentContainerClass || '')">
      <ng-content select="[popup-content]"></ng-content>
    </mat-dialog-content>
    <mat-dialog-actions [class]="'actions-container ' + (actionsContainerClass || '')">
      <ng-content select="[popup-actions]"></ng-content>
    </mat-dialog-actions>
  </div>
</wlm-spinner-wrapper>
